<template>
  <div class="app-exceptions-resolver">
    <pending-invoice-generation
      v-if="isPendingInvoiceGeneration"
    ></pending-invoice-generation>

    <free-events-limit />
    <events-limit-notice />

    <unpaid-invoices-dialog
      v-if="isUnpaidInvoicesError"
    ></unpaid-invoices-dialog>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';

import UnpaidInvoicesDialog from './dialogs/unpaid-invoices-dialog/unpaid-invoices-dialog.vue';
import { AppErrorEnum } from '@/services/models/Enums';
import FreeEventsLimit from '@/components/app-exceptions-resolver/dialogs/free-events-limit.vue';
import EventsLimitNotice from '@/components/app-exceptions-resolver/dialogs/events-limit-notice.vue';
import PendingInvoiceGeneration from '@/components/app-exceptions-resolver/dialogs/pending-invoice-generation.vue';
import { useStore } from '@/store';

const store = useStore();
const isLimitError = computed(
  () =>
    store.appError === AppErrorEnum.freePlanLimitsExceeded &&
    !store.user?.pendingInvoiceGeneration,
);

const isPendingInvoiceGeneration = computed(() => !!store.user?.pendingInvoiceGeneration);

const isUnpaidInvoicesError = computed(() => store.appError === AppErrorEnum.unpaidInvoices);

const isPanelBlocked = computed(
  () => !!(isLimitError.value || isUnpaidInvoicesError.value || store.user?.blockedCampaigns),
);

watch(
  isPanelBlocked,
  (value) => {
    store.setPanelBlocked(value);
  },
  { immediate: true },
);
</script>
